import { HomeWorkOutlined } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { CircularProgress, IconButton, Tooltip } from '@mui/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const HomePriceButtonOutlined = (props: {
  isManuallySet: boolean
  handleResetToDefaults: () => void
  isLoading: boolean
  translationKey?: string
  /**
   * make it true to not show the reset button (e.g. when the project is not editable)
   */
  hidden: boolean
  variant?: 'text' | 'icon'
}) => {
  const { t } = useTranslation()

  const IconVariant = useMemo(() => {
    if (props.variant === 'text') {
      return null
    }
    return (
      <Tooltip title={props.translationKey || t('project:reset-to-default')}>
        <IconButton
          onClick={props.handleResetToDefaults}
          color="default"
          size="small"
          disabled={props.hidden}
        >
          {props.isLoading ? (
            <CircularProgress size={14} />
          ) : (
            <HomeWorkOutlined fontSize="small" />
          )}
          {/* <HomeWorkOutlined
          className="reset-button"
          // color="disabled"
          style={{ cursor: 'pointer', width: '24px' }}
        /> */}
        </IconButton>
      </Tooltip>
    )
  }, [
    props.handleResetToDefaults,
    props.hidden,
    props.isLoading,
    props.translationKey,
    props.variant,
    t,
  ])

  const TextVariant = useMemo(() => {
    return (
      <LoadingButton
        size="small"
        onClick={props.handleResetToDefaults}
        disabled={props.hidden}
        loading={props.isLoading}
      >
        {props.translationKey || t('project:reset-to-default')}
      </LoadingButton>
    )
  }, [
    props.handleResetToDefaults,
    props.hidden,
    props.isLoading,
    props.translationKey,
    t,
  ])

  if (!props.isManuallySet || props.hidden) {
    return null
  }

  switch (props.variant) {
    case 'text':
      return <>{TextVariant}</>
    case 'icon':
    default:
      return <>{IconVariant}</>
  }
}
